var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1410.79 356.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #7f622e;\n      }\n\n      .cls-3 {\n        fill: #aa9767;\n      }\n\n      .cls-4 {\n        fill: #081f40;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-11);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 260.67,
    y1: 122.32,
    x2: 260.67,
    y2: 309.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 260.67,
    y1: 279.46,
    x2: 260.67,
    y2: 156.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 512.79,
    y1: 60.83,
    x2: 512.79,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 477.94,
    y1: 60.83,
    x2: 477.94,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 568.29,
    y1: 60.83,
    x2: 568.29,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 520.33,
    y1: 60.83,
    x2: 520.33,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 525.93,
    y1: 60.83,
    x2: 525.93,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 561.11,
    y1: 60.83,
    x2: 561.11,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 503.86,
    y1: 60.83,
    x2: 503.86,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 532.87,
    y1: 60.83,
    x2: 532.87,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 552.15,
    y1: 60.83,
    x2: 552.15,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 559.6,
    y1: 60.83,
    x2: 559.6,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 455.6,
    y1: 60.83,
    x2: 455.6,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 571.52,
    y1: 60.83,
    x2: 571.52,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 464.51,
    y1: 60.83,
    x2: 464.51,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 490.52,
    y1: 60.83,
    x2: 490.52,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 466.34,
    y1: 60.83,
    x2: 466.34,
    y2: 223.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 767.49,
    y1: 288.13,
    x2: 767.49,
    y2: 84.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 786.56,
    y1: 288.13,
    x2: 786.56,
    y2: 84.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f622e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9767"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m516.57,15.38c-72.73,0-132.43,55.74-138.74,126.84-24.8-38.45-68-63.91-117.16-63.91-63.01,0-116.24,41.84-133.45,99.24v-106.08H30.53L0,134.31h63.19v193.29h64.03v-69.93c17.21,57.41,70.44,99.24,133.45,99.24,72.73,0,132.44-55.74,138.74-126.83,24.8,38.45,68,63.91,117.16,63.91,76.94,0,139.31-62.37,139.31-139.3S593.51,15.38,516.57,15.38Zm-255.91,276.26c-40.89,0-74.03-33.14-74.03-74.03s33.14-74.03,74.03-74.03,74.03,33.14,74.03,74.03-33.14,74.03-74.03,74.03Zm255.9-62.92c-40.89,0-74.03-33.14-74.03-74.03s33.14-74.03,74.03-74.03,74.03,33.14,74.03,74.03-33.14,74.03-74.03,74.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m333.81,217.6c0,32.42-21.73,61.33-52.84,70.29-6.57,1.89-13.4,2.85-20.31,2.85-1.53,0-3.11-.05-4.68-.14-7.69-.49-15.22-2.18-22.38-5.02-27.99-11.16-46.08-37.84-46.08-67.98,0-34.64,24.59-64.78,58.48-71.68,4.79-.97,9.72-1.47,14.66-1.47,21.29,0,41.48,9.25,55.41,25.38,11.44,13.26,17.74,30.22,17.74,47.77m13.53-14.97c-7.04-2.34-12.72-7.62-15.57-14.49-2.84-6.86-2.56-14.6.76-21.24l2.06-4.1-19.12-19.12-4.1,2.05c-6.64,3.32-14.39,3.6-21.25.76-6.86-2.84-12.14-8.51-14.49-15.56l-1.45-4.35h-27.04l-1.45,4.35c-2.35,7.05-7.63,12.72-14.49,15.56-6.86,2.84-14.61,2.56-21.25-.76l-4.1-2.05-19.12,19.12,2.06,4.1c3.33,6.64,3.6,14.39.76,21.24-2.84,6.86-8.51,12.15-15.56,14.49l-4.35,1.45v27.04l4.35,1.45c7.05,2.34,12.72,7.62,15.56,14.49,2.84,6.86,2.57,14.6-.76,21.24l-2.06,4.1,19.12,19.12,4.1-2.05c6.64-3.33,14.39-3.6,21.25-.76,6.86,2.84,12.14,8.51,14.49,15.56l1.45,4.35h27.04l1.45-4.35c2.35-7.05,7.63-12.72,14.49-15.56s14.6-2.56,21.25.76l4.1,2.05,19.12-19.12-2.06-4.1c-3.32-6.64-3.6-14.38-.76-21.24,2.85-6.87,8.52-12.15,15.57-14.49l4.35-1.45v-27.04l-4.35-1.45Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m101.46,10.64c.3,0,.54-.24.54-.54V.57c0-.3-.24-.54-.54-.54h-34.25q-.29,0,0,0h2.47q.3,0,0,0h-2.77c-.3,0-.54.24-.54.54v48.19c0,.3,0,.54,0,.54h35.09c.3,0,.54-.24.54-.54v-9.54c0-.29-.24-.54-.54-.54h-23.89c-.3,0-.54-.24-.54-.54v-7.78c0-.3.24-.54.54-.54h11.91c.3,0,.54-.24.54-.54v-9.54c0-.3-.24-.54-.54-.54h-11.91c-.3,0-.54-.24-.54-.54v-7.47c0-.3.24-.54.54-.54h23.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m303.63.95h-3.49c-13.28,0-22.39,3.89-22.39,21.93v4.6c0,19.24,11.29,22.32,22.71,22.61.69.02,1.89.02,2.45,0,11.56-.23,23.1-3.16,23.1-22.62v-4.6c0-18.04-9.1-21.93-22.39-21.93m1.53,38.44h-6.55c-5.74,0-9.69-1.89-9.7-8.02v-12.5c0-5.19,3.59-7.3,11.13-7.3h3.68c7.54,0,11.14,2.12,11.13,7.3v12.5c0,6.13-3.96,8.02-9.7,8.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m239.7,0c-.3,0-.54.24-.54.54v28.09c0,.3-.16.36-.36.15L212.59.4c-.2-.22-.61-.4-.91-.4h-5.88c-.3,0-.54.24-.54.54v48.36c0,.29.25.54.55.54h9.53c.29,0,.54-.24.54-.54v-28.09c0-.29.17-.36.37-.14l26.21,28.37c.2.22.61.4.91.4h5.88c.3,0,.54-.24.54-.54V.54c0-.3-.24-.54-.54-.54h-9.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m369.31,0c-.3,0-.54.24-.54.54v28.08c.01.3-.16.37-.35.15L342.2.4c-.2-.22-.61-.4-.91-.4h-5.89c-.3,0-.54.24-.54.54v48.35c0,.3.25.54.54.54h9.53c.29,0,.54-.24.54-.54v-28.09c0-.29.17-.36.36-.14l26.21,28.37c.2.22.61.4.91.4h5.88c.3,0,.54-.24.54-.54V.54c0-.3-.25-.54-.54-.54h-9.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m269.58,48.73c0,.3-.24.54-.54.54h-9.53c-.3,0-.54-.24-.54-.54V.54c0-.3.24-.54.54-.54h9.53c.3,0,.54.24.54.54v48.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m185.61,0c-.3,0-.54.24-.54.54v18.2c0,.3-.24.54-.54.54h-21.02c-.29,0-.54-.24-.54-.54V.54c0-.3-.24-.54-.54-.54h-9.54c-.3,0-.54.24-.54.54v48.19c0,.3.24.54.54.54h9.54c.3,0,.54-.24.54-.54v-18.3c0-.29.24-.54.54-.54h21.02c.3,0,.54.24.54.54v18.3c0,.3.24.54.54.54h9.54c.3,0,.54-.24.54-.54V.54c0-.3-.24-.54-.54-.54h-9.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m59.08.54c0-.3-.24-.54-.54-.54H17.03c-.3,0-.54.24-.54.54v9.54c0,.3.24.54.54.54h14.91c.3,0,.54.24.54.54v37.57c0,.3.24.54.54.54h9.54c.3,0,.54-.24.54-.54V11.16c0-.3.24-.54.54-.54h14.91c.3,0,.54-.24.54-.54V.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m130.56.24l12.11.32s.22.04.37.16c.15.13.17.35.17.35v9.44c0,.25-.1.37-.15.43-.11.13-.33.17-.54.18l-12.05-.27c-7.54,0-11.14,2.11-11.13,7.3v12.5c0,6.13,3.8,7.87,9.7,8.02,5.89.16,13.55-.33,13.55-.33,0,0,.27-.02.47.16.19.17.18.37.18.37l-.02,9.41s0,.29-.19.47c-.2.19-.57.18-.57.18,0,0-1.13.5-9.5.47-12.19-.05-24.78-2.24-24.78-22.64v-4.6c0-18.04,9.1-21.93,22.39-21.93"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m303.41,217.6c0,18.95-12.7,35.84-30.88,41.08-3.84,1.11-7.83,1.67-11.87,1.67-.89,0-1.81-.03-2.74-.08-4.5-.28-8.9-1.27-13.08-2.93-16.36-6.52-26.93-22.12-26.93-39.73,0-20.24,14.37-37.86,34.18-41.89,2.8-.57,5.68-.86,8.57-.86,12.44,0,24.24,5.41,32.38,14.83,6.69,7.75,10.37,17.66,10.37,27.91m10.99-9.28c-4.37-1.45-7.88-4.72-9.65-8.98-1.76-4.25-1.59-9.05.47-13.17l1.28-2.54-11.86-11.85-2.54,1.27c-4.12,2.06-8.92,2.23-13.17.47-4.25-1.76-7.53-5.28-8.98-9.65l-.9-2.7h-16.77l-.9,2.7c-1.45,4.37-4.73,7.89-8.98,9.65-4.25,1.76-9.06,1.59-13.17-.47l-2.54-1.27-11.86,11.85,1.28,2.54c2.06,4.12,2.23,8.92.47,13.17-1.76,4.26-5.28,7.53-9.65,8.98l-2.7.9v16.77l2.7.9c4.37,1.45,7.88,4.72,9.65,8.98,1.76,4.25,1.59,9.05-.47,13.17l-1.28,2.54,11.86,11.85,2.54-1.27c4.12-2.06,8.92-2.23,13.17-.47,4.25,1.76,7.53,5.28,8.98,9.65l.9,2.7h16.77l.9-2.7c1.46-4.37,4.73-7.89,8.98-9.65,4.25-1.76,9.05-1.59,13.17.47l2.54,1.27,11.86-11.85-1.28-2.54c-2.06-4.12-2.23-8.92-.47-13.17,1.77-4.26,5.28-7.53,9.65-8.98l2.69-.9v-16.77l-2.69-.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m500.09,134.05l13.53,7.8c-.18.59-.27,1.23-.27,1.88,0,1.85.73,3.5,1.94,4.71s2.88,1.94,4.73,1.94,3.48-.73,4.69-1.94c1.21-1.21,1.94-2.88,1.94-4.71s-.73-3.48-1.94-4.69-2.86-1.96-4.69-1.96c-1.37,0-2.64.41-3.7,1.12l-12.84-7.41v-48.95c-1.53.27-3.04.59-4.54.95v50.6l1.15.66Zm17.23,7c.68-.71,1.63-1.12,2.71-1.12,1.02,0,2,.41,2.68,1.12.68.68,1.12,1.63,1.12,2.68s-.44,2.03-1.12,2.71c-.68.68-1.66,1.12-2.68,1.12-1.08,0-2.03-.44-2.71-1.12-.71-.68-1.12-1.66-1.12-2.71s.41-2,1.12-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m479.08,111.3c-.46.92-.69,1.93-.69,2.93,0,1.71.65,3.4,1.96,4.7,1.31,1.31,3,1.96,4.7,1.96,1.71,0,3.42-.65,4.72-1.95,1.3-1.3,1.94-3.01,1.94-4.71s-.65-3.4-1.96-4.7c-1.31-1.31-3-1.96-4.7-1.96-.92,0-1.84.19-2.7.58l-9.96-9.97-1.01-.13-2.4-.06c-1.66,1.4-3.27,2.86-4.81,4.4l6.16.15,8.76,8.76Zm3.26.22c.77-.77,1.75-1.13,2.71-1.13,1.01,0,1.97.38,2.71,1.13.74.74,1.1,1.73,1.13,2.71,0,.96-.36,1.94-1.13,2.71s-1.73,1.1-2.71,1.13c-.98-.02-1.97-.38-2.71-1.13-.74-.74-1.1-1.73-1.13-2.71.02-.98.38-1.97,1.13-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m563.59,117.02c-1.21,1.21-1.96,2.86-1.96,4.71s.75,3.5,1.96,4.71c1.19,1.21,2.86,1.94,4.71,1.94s3.5-.73,4.71-1.94c1.21-1.21,1.94-2.86,1.94-4.71s-.73-3.5-1.94-4.71c-.68-.68-1.52-1.22-2.45-1.55v-11.39c-1.45-1.55-2.96-3.04-4.54-4.46v15.85c-.93.33-1.76.86-2.43,1.55Zm7.42,1.99c.68.68,1.12,1.66,1.12,2.71s-.44,2-1.12,2.71c-.71.68-1.66,1.12-2.71,1.12s-2.04-.44-2.71-1.12c-.71-.71-1.12-1.66-1.12-2.71s.41-2.03,1.12-2.71c.68-.68,1.63-1.12,2.71-1.12s2,.44,2.71,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m515.63,117.02c-1.2,1.21-1.96,2.86-1.96,4.71s.75,3.5,1.96,4.71c1.19,1.21,2.86,1.94,4.71,1.94s3.5-.73,4.71-1.94c1.21-1.21,1.94-2.86,1.94-4.71s-.73-3.5-1.94-4.71c-.68-.68-1.52-1.22-2.45-1.55v-34.55c-1.5-.12-3.01-.2-4.54-.23v34.78c-.93.33-1.76.86-2.43,1.55Zm7.43,1.99c.68.68,1.12,1.66,1.12,2.71s-.44,2-1.12,2.71c-.71.68-1.66,1.12-2.71,1.12s-2.04-.44-2.71-1.12c-.71-.71-1.12-1.66-1.12-2.71s.41-2.03,1.12-2.71c.68-.68,1.63-1.12,2.71-1.12s2,.44,2.71,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m520.8,173.77c-.89-.45-1.9-.7-2.95-.7-1.83,0-3.5.75-4.71,1.96-1.2,1.21-1.96,2.86-1.96,4.71s.75,3.5,1.96,4.71c1.21,1.21,2.88,1.96,4.71,1.96s3.5-.75,4.69-1.96c1.21-1.21,1.96-2.86,1.96-4.71,0-.95-.2-1.85-.56-2.67l16.23-20.07.51-.64v-71.67c-1.49-.51-2.99-.98-4.52-1.4v71.5l-15.35,18.97Zm-.26,8.68c-.65.68-1.63,1.12-2.68,1.12s-2.03-.44-2.71-1.12c-.68-.71-1.12-1.66-1.12-2.71s.44-2,1.12-2.71c.68-.71,1.66-1.12,2.71-1.12s2.03.41,2.68,1.12c.71.71,1.12,1.66,1.12,2.71s-.41,2-1.12,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m550.01,138.36l10.39,8.33c-.42.87-.65,1.84-.65,2.86,0,1.83.75,3.5,1.96,4.71,1.21,1.21,2.86,1.94,4.69,1.94s3.5-.73,4.71-1.94c1.2-1.21,1.94-2.88,1.94-4.71s-.73-3.5-1.94-4.69c-1.21-1.21-2.86-1.96-4.71-1.96-.98,0-1.91.22-2.76.61l-9.94-7.99v-44.85c-1.48-.86-2.99-1.68-4.54-2.44v49.44l.85.7Zm13.69,8.49c.68-.71,1.63-1.12,2.68-1.12s2.04.41,2.71,1.12c.68.68,1.12,1.63,1.12,2.68s-.44,2.03-1.12,2.71c-.68.68-1.63,1.12-2.71,1.12s-2-.44-2.68-1.12c-.71-.68-1.12-1.66-1.12-2.71s.41-2,1.12-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m504.69,170c.61.18,1.25.28,1.91.28,1.85,0,3.5-.73,4.73-1.94,1.19-1.21,1.94-2.86,1.94-4.71s-.75-3.48-1.94-4.69c-1.22-1.21-2.88-1.96-4.73-1.96s-3.5.75-4.71,1.96c-1.19,1.21-1.94,2.86-1.94,4.69,0,1.36.41,2.62,1.1,3.67l-6.13,8.12-.47.68v49.26c1.49.47,3.01.87,4.54,1.24v-49.06l5.69-7.55Zm-.78-9.06c.68-.71,1.63-1.15,2.68-1.15s2.03.44,2.71,1.15c.71.64,1.12,1.63,1.12,2.68s-.41,2.04-1.12,2.71c-.68.68-1.63,1.12-2.71,1.12s-2-.44-2.68-1.12c-.71-.68-1.12-1.66-1.12-2.71s.41-2.03,1.12-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m518.41,207.22c.3-.75.47-1.57.47-2.43,0-1.85-.75-3.5-1.96-4.71-1.21-1.21-2.86-1.94-4.71-1.94s-3.48.73-4.69,1.94c-1.21,1.21-1.96,2.86-1.96,4.71s.75,3.48,1.96,4.69c1.21,1.21,2.86,1.96,4.69,1.96,1.17,0,2.26-.3,3.22-.83l9.76,7.91.64.51h27.33c2.43-1.39,4.78-2.9,7.02-4.54h-32.78l-9-7.27Zm-3.49.25c-.68.71-1.66,1.12-2.71,1.12s-2-.41-2.68-1.12c-.71-.68-1.15-1.66-1.15-2.68s.44-2.03,1.15-2.71c.68-.68,1.63-1.12,2.68-1.12s2.04.44,2.71,1.12c.71.68,1.12,1.66,1.12,2.71s-.41,2-1.12,2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m538.5,194.26c-1.21-1.21-2.86-1.96-4.71-1.96s-3.48.75-4.69,1.96c-1.21,1.21-1.94,2.86-1.96,4.69,0,1.85.75,3.5,1.96,4.71,1.21,1.21,2.86,1.94,4.69,1.94s3.5-.73,4.71-1.94c.55-.55,1.01-1.2,1.35-1.92h33.88c1.21-1.46,2.34-2.98,3.43-4.54h-36.93c-.31-1.12-.92-2.13-1.72-2.94Zm-1.99,7.4c-.68.68-1.66,1.12-2.71,1.12s-2-.44-2.68-1.12c-.71-.68-1.15-1.66-1.15-2.71s.44-2.03,1.15-2.68c.68-.71,1.63-1.12,2.68-1.12s2.03.41,2.71,1.12c.71.64,1.12,1.63,1.12,2.68s-.41,2-1.12,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m544.34,177.34c-1.19-1.21-2.86-1.94-4.69-1.94s-3.5.73-4.71,1.94c-1.2,1.21-1.96,2.86-1.96,4.71s.75,3.48,1.96,4.69c1.21,1.21,2.86,1.96,4.71,1.96s3.5-.75,4.69-1.96c.69-.68,1.23-1.51,1.56-2.43h38.51c.65-1.49,1.26-3,1.81-4.54h-40.32c-.34-.92-.87-1.75-1.56-2.43Zm-1.98,7.39c-.71.71-1.66,1.12-2.71,1.12s-2.04-.41-2.71-1.12c-.71-.68-1.12-1.63-1.12-2.68s.41-2.03,1.12-2.71c.68-.68,1.63-1.12,2.71-1.12s2,.44,2.71,1.12c.68.68,1.12,1.66,1.12,2.71s-.44,2-1.12,2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m456.6,147.03c1.21,1.21,2.86,1.96,4.71,1.96s3.5-.75,4.71-1.96c1.21-1.19,1.94-2.86,1.94-4.71s-.73-3.5-1.94-4.71c-1.21-1.21-2.86-1.94-4.71-1.94s-3.5.73-4.71,1.94c-.68.68-1.22,1.52-1.55,2.45h-11.07c-.3,1.5-.54,3.01-.75,4.54h11.82c.33.93.86,1.76,1.55,2.43Zm1.99-7.42c.68-.68,1.66-1.12,2.71-1.12s2,.44,2.71,1.12c.68.71,1.12,1.66,1.12,2.71s-.44,2.04-1.12,2.71c-.71.71-1.66,1.12-2.71,1.12s-2.03-.41-2.71-1.12c-.68-.68-1.12-1.63-1.12-2.71s.44-2,1.12-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m566.01,164.24c-.33-.92-.87-1.75-1.56-2.43-1.19-1.2-2.86-1.94-4.69-1.94s-3.5.74-4.71,1.94c-1.21,1.21-1.96,2.86-1.96,4.71s.75,3.48,1.96,4.69,2.86,1.96,4.71,1.96,3.5-.75,4.69-1.96c.69-.68,1.23-1.51,1.56-2.43h23.22c.29-1.5.52-3.01.72-4.54h-23.94Zm-3.54,4.96c-.71.71-1.66,1.12-2.71,1.12s-2.04-.41-2.71-1.12c-.71-.68-1.12-1.63-1.12-2.68s.41-2.03,1.12-2.71c.68-.68,1.63-1.12,2.71-1.12s2,.44,2.71,1.12c.68.68,1.12,1.66,1.12,2.71s-.44,2-1.12,2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m478.55,150.24v-14.09c.88-.33,1.66-.85,2.32-1.5,1.21-1.21,1.94-2.86,1.94-4.71s-.73-3.5-1.94-4.71c-1.21-1.21-2.86-1.96-4.71-1.96s-3.5.75-4.71,1.96c-1.21,1.21-1.94,2.86-1.94,4.71s.73,3.5,1.94,4.71c.71.71,1.59,1.26,2.56,1.59v12.39l-27.8,29.15c.52,1.6,1.1,3.17,1.73,4.72l29.99-31.44.62-.81Zm-5.11-17.59c-.68-.71-1.12-1.66-1.12-2.71s.44-2,1.12-2.71c.71-.68,1.66-1.12,2.71-1.12s2.03.44,2.71,1.12c.68.71,1.12,1.66,1.12,2.71s-.41,2-1.12,2.71-1.63,1.12-2.71,1.12-2-.44-2.71-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m493.71,152.62c.51.12,1.03.19,1.58.19,1.84,0,3.5-.75,4.71-1.96,1.19-1.21,1.94-2.86,1.94-4.71s-.75-3.5-1.94-4.71c-1.2-1.21-2.86-1.94-4.71-1.94s-3.5.73-4.71,1.94c-1.21,1.21-1.96,2.86-1.96,4.71,0,1.49.49,2.85,1.31,3.96l-10.33,13.18-.51.62v54.63c1.48.87,2.99,1.69,4.54,2.46v-55.53l10.08-12.85Zm-1.14-9.19c.71-.68,1.66-1.12,2.71-1.12s2,.44,2.71,1.12c.68.71,1.12,1.66,1.12,2.71s-.44,2.03-1.12,2.71c-.71.71-1.66,1.12-2.71,1.12s-2-.41-2.71-1.12c-.71-.68-1.12-1.63-1.12-2.71s.41-2,1.12-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m471.04,185.84c1.21-1.2,1.96-2.86,1.96-4.71s-.75-3.5-1.96-4.71c-1.19-1.21-2.86-1.94-4.71-1.94s-3.5.73-4.71,1.94c-1.21,1.21-1.94,2.86-1.94,4.71s.73,3.5,1.94,4.71c.68.68,1.52,1.22,2.45,1.55v19.5c1.45,1.46,2.97,2.85,4.54,4.18v-23.68c.93-.33,1.76-.86,2.43-1.55Zm-7.43-2c-.68-.68-1.12-1.66-1.12-2.71s.44-2,1.12-2.71c.71-.68,1.66-1.12,2.71-1.12s2.04.44,2.71,1.12c.71.71,1.12,1.66,1.12,2.71s-.41,2.03-1.12,2.71c-.68.68-1.63,1.12-2.71,1.12s-2-.44-2.71-1.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m556.16,312.07c5.21,3.02,79.01,39.14,116.87-9.27-41.86,11.17-79.3,1.56-115.26-15-9.85,3.04-20.16,5.03-30.81,5.81,9.66,6.51,19.37,12.77,29.2,18.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m491.95,300.66c43.24,42.25,72.55,28.37,72.55,28.37-18.66-10.07-36.23-22.42-53.14-35.15-11.61-.43-22.86-2.27-33.58-5.37,4.45,4.05,9.15,8.12,14.17,12.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m651.91,289.13c26.54-4.66,65.13-26.05,82.7-73.17-48.73,39.29-91.44,50.26-131.28,47.72-9.25,7.37-19.45,13.59-30.4,18.43,25.08,8.15,51.1,11.92,78.99,7.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m392.11,217.3c47.89,11.62,90.81,46.61,134.85,76.3,10.65-.79,20.96-2.77,30.81-5.81-55.96-25.78-108.35-68.38-168.21-75.8.81,1.79,1.66,3.56,2.55,5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m399.08,229.55c26.67,10.75,51.91,31.45,78.51,58.9,10.8,3.14,22.15,5.01,33.87,5.43-37.51-27.9-74.47-58.22-115.73-69.86,1.08,1.87,2.2,3.71,3.36,5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m603.32,263.68c-75.53-4.82-140.73-58.25-217.02-59.56.23.62.46,1.23.71,1.85,65.77,7.53,122.85,55.67,185.9,76.15,10.95-4.85,21.16-11.06,30.4-18.43Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "862.18 166.09 862.18 210.85 848.26 210.85 848.26 166.09 833.87 166.09 833.87 155.12 876.48 155.12 876.48 166.09 862.18 166.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "906.05 155.12 946.86 155.12 946.86 165.94 919.81 165.94 919.81 176.04 945.07 176.04 945.07 186.62 919.81 186.62 919.81 199.88 949.29 199.88 949.29 210.85 906.05 210.85 906.05 155.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1029.6,198.14c-4.38,7.74-12.28,14.37-23.77,14.37-14.62,0-26.43-10.73-26.43-29.6,0-16.49,11.11-29.52,26.74-29.52,10.17,0,19.39,6.08,23.3,14.44l-10.94,5.53c-1.18-4.19-6.1-8.53-11.73-8.53-8.92,0-13.61,8.37-13.61,17.68,0,12.24,6.18,18.31,13.61,18.31s10.09-5.05,11.96-8.28l10.87,5.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1094.12 210.85 1094.12 187.09 1073.95 187.09 1073.95 210.85 1060.03 210.85 1060.03 155.12 1073.95 155.12 1073.95 175.25 1094.12 175.25 1094.12 155.12 1107.96 155.12 1107.96 210.85 1094.12 210.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1178.19 210.85 1158.64 177.54 1158.64 210.85 1145.35 210.85 1145.35 155.12 1158.88 155.12 1178.5 189.06 1178.5 155.12 1191.71 155.12 1191.71 210.85 1178.19 210.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1229.1,
    y: 155.12,
    width: 13.76,
    height: 55.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1304.25,200.66c10.24,0,13.91-9.63,13.91-17.44,0-10.11-4.38-18.16-14.15-18.16-10.48,0-13.68,10.03-13.68,17.53,0,8.92,3.98,18.07,13.92,18.07m-.24-47.28c20.1,0,27.99,16.74,27.99,30,0,14.92-10.09,29.12-27.83,29.12s-27.45-14.44-27.45-29.75c0-12.71,7.35-29.36,27.29-29.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1397.23 155.12 1397.23 189.06 1377.6 155.12 1364.08 155.12 1364.08 210.85 1377.37 210.85 1377.37 177.53 1396.92 210.85 1410.44 210.85 1410.44 155.12 1397.23 155.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m852.78,86.92l-6.44,17.76h12.58l-6.14-17.76Zm12.41,35.53l-4.59-13.01h-16.05l-4.71,13.01h-5.97l16.05-42.51h5.84l15.33,42.51h-5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m949.48,122.45c0-1.15.78-35.65.78-35.65l-13.3,35.65h-4.36l-13.06-35.11s.6,33.84.6,35.11h-5.49v-42.51h7.28l12.89,34.87,13-34.87h7.28v42.51h-5.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1005.02 122.45 1005.02 79.93 1034.02 79.93 1034.02 84.93 1010.39 84.93 1010.39 98.06 1030.91 98.06 1030.91 103 1010.39 103 1010.39 117.51 1034.73 117.51 1034.73 122.45 1005.02 122.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1100.17,99.63c4.83,0,9.18-1.45,9.18-7.29,0-4.76-3.04-7.71-8.41-7.71h-13.18v15h12.41Zm9.96,22.82l-11.51-18.06h-10.86v18.06h-5.49v-42.51h18.97c8.06,0,13.66,3.85,13.66,12.4,0,5.18-2.2,10.42-9.9,11.68l11.81,18.43h-6.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1162.69,
    y: 79.93,
    width: 5.66,
    height: 42.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1256.65,107.03c-1.43,6.87-7.46,16.5-20.76,16.5s-20.58-9.03-20.58-22.34,7.93-22.34,21.29-22.34c10.02,0,16.41,4.88,19.21,13.01l-5.67,1.14c-1.49-4.76-5.73-9.64-13.6-9.64-9.61,0-15.03,7.17-15.03,17.53,0,12.16,6.62,17.89,15.09,17.89,6.56,0,12.59-3.85,13.96-12.47l6.09.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1315.05,86.92l-6.44,17.76h12.58l-6.14-17.76Zm12.41,35.53l-4.59-13.01h-16.05l-4.71,13.01h-5.97l16.05-42.51h5.84l15.33,42.51h-5.91Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1405.37,122.45l-23.08-34.57s.54,33.73.54,34.57h-5.31v-42.51h5.31l22.79,34.09s-.24-32.76-.24-34.09h5.07v42.51h-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m839.53,272.73c.06,1.68.42,11,12.08,11,3.51,0,10.48-1.39,10.48-8.47,0-4.75-3.45-6.13-7.98-7.03l-3.81-.78c-9.46-1.92-14.77-4.99-14.77-12.08,0-3.37,1.49-6.19,3.99-8.29,4.05-3.37,8.87-3.48,10.9-3.48,4.16,0,8.21.54,11.61,3.19,3.69,2.83,4.65,5.89,5.36,9.86l-5.66.36c0-2.4-1.31-9.01-10.83-9.01-3.99,0-9.58,1.44-9.58,6.67,0,4.09,3.63,5.53,8.39,6.67l7.68,1.86c1.97.48,10.72,2.4,10.72,11.72,0,1.68-.24,5.47-3.51,8.71-2.32,2.29-6.13,4.57-13.27,4.57-1.37,0-7.09-.06-11.49-2.94-5.59-3.67-6.13-9.92-6.31-11.72l6.01-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m950.2,283.73c8.34,0,14.94-5.65,14.94-18.21,0-8.41-3.75-17.37-15.06-17.37s-15.12,8.89-15.12,17.73c0,10.93,5.77,17.85,15.24,17.85m-.3,4.44c-10.89,0-21.01-7.15-21.01-22.36s10.42-22.23,21.19-22.23c12.8,0,21.13,9.07,21.13,21.94,0,10.34-5.59,22.65-21.31,22.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1073.19,271.71c-1.43,6.85-7.44,16.47-20.72,16.47s-20.54-9.02-20.54-22.29,7.92-22.29,21.25-22.29c10,0,16.37,4.87,19.17,12.98l-5.66,1.14c-1.49-4.75-5.71-9.61-13.57-9.61-9.58,0-15,7.15-15,17.49,0,12.14,6.61,17.85,15.06,17.85,6.55,0,12.56-3.85,13.93-12.44l6.07.72Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1133.32,
    y: 244.67,
    width: 5.66,
    height: 42.43
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1203.74 287.09 1203.74 244.67 1232.67 244.67 1232.67 249.66 1209.1 249.66 1209.1 262.75 1229.58 262.75 1229.58 267.68 1209.1 267.68 1209.1 282.17 1233.39 282.17 1233.39 287.09 1203.74 287.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1307.45 249.59 1307.45 287.09 1301.85 287.09 1301.85 249.59 1289.23 249.59 1289.23 244.67 1320.01 244.67 1320.01 249.59 1307.45 249.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1404.13 244.67 1392.93 262.64 1381.86 244.67 1375.25 244.67 1390.02 267.68 1390.02 287.09 1395.67 287.09 1395.67 267.68 1410.79 244.67 1404.13 244.67"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 764.58,
    y: 78.85,
    width: 5.84,
    height: 208.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 783.65,
    y: 78.85,
    width: 5.84,
    height: 208.21
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d6db581fef0028ea50721fd5b6b722af.svg";
export { ForwardRef as ReactComponent };